"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

// TODO : handle disabled with ng-disabled
// TODO : how to wire to sp-field
// TODO : open up or down depending on absolute position on the screen
// TODO : permettre la deselection
// TODO : specifier le placeholder
// TODO : ouvrir la popin quand on commence à tapper du texte
// TODO : allow alternative template for selected option
/**
 * ex :
 *<pre>
 * <tl-select ng-model="emprunt.devise" base-config-name="currency"  options="currencies"></tl-select>
 * </pre>
 * <pre>
 * <tl-select ng-model="test.currency" base-config-name="currency"  select-config="currencySelectConfig" empty-option-label="Aucune">
 *</pre>
 *  avec
 * $scope.currencySelectConfig = {
 options : "currencies",
 idAttribute : "isoCode",
 groupBy : "majorCurrency"
 };

 *<br/><br/>
 * attention, l'initialisation (et la lecture des attributs) est faite dans le link. Résultat le config associcée à select-config
 * peut ne pas être trouvée dans le $scope si elle est déclarée dans un controller qui serait chargé après la directive. Cela arrive
 * avec les $modal. J'ai implementé un watch pour contourner le soucis, mais cela reste à valider à l'épreuve des utilisations.
 *
 */
ngModule.directive("tlSelect", function (keyCodes, $q, $timeout, $parse, $debounce, $compile, stringUtils, objectUtils, templateUtils, tlSelectConfigRegistry) {
  var defaultSelectConfig = {
    idAttribute: "id",
    groupBy: null,
    groupLabelTemplate: "<span>{{::group.value}}</span>",
    showSearch: true,
    matcher: function matcher(text, option) {
      for (var attribute in option) {
        if (option.hasOwnProperty(attribute)) {
          var value = option[attribute];
          if (_.isString(value) && stringUtils.containsIgnoringCaseAndAccents(value, text)) {
            return true;
          }
        }
      }
      return false;
    }
  };
  return {
    restrict: "E",
    replace: true,
    transclude: true,
    scope: true,
    template: require("./tlSelect.html"),
    controllerAs: "$select",
    require: ["tlSelect", "ngModel"],
    link: function link($scope, $el, $attrs, controllers) {
      var tlSelect = controllers[0],
        ngModel = controllers[1];
      tlSelect.setModelCtrl(ngModel);
      tlSelect._initialize();
    },
    controller: function controller($scope, $element, $attrs) {
      var ctrl = this,
        source = null,
        config = null,
        modelCtrl = null,
        dropdownEl = null,
        optionTranscludeFn = null,
        groupLabelTranscludeFn = null,
        valueAtOpening = null,
        unwatchSelectConfig = null,
        unwatchSource;
      ctrl.state = {
        focused: false,
        opened: false,
        ignoreHover: false,
        activeOptionIdx: null,
        selectedOption: null,
        searchTerm: "",
        // true si la source qui fourni les options est chargée (pas à undefined)
        sourceLoaded: false,
        // true si les options ont pu être construites, on peut retirer les loader et afficher l'accès a la liste d'options
        loadingRenderDone: false
      };
      var focusIsInsideWidget = function focusIsInsideWidget() {
        var focusParents = $(document.activeElement).parents().addBack();
        return focusParents.index($element) > -1 || focusParents.index(dropdownEl) > -1;
      };
      ctrl.setModelCtrl = function (ngModel) {
        modelCtrl = ngModel;
        wireToModel();
      };
      ctrl._initialize = function () {
        ctrl.processConfiguration();
        unwatchSource = watchSource();
        watchSearch();
      };
      ctrl.getConfig = function () {
        return config;
      };

      // we need to wait for the dropdown element to link it's template to access the real element.
      ctrl.setDropdownCtrl = function (dropdownCtrl) {
        dropdownEl = dropdownCtrl.getElement();
        bindEvents();
      };
      ctrl.shouldDisplayOption = function (option) {
        return config.optionsFilter(option);
      };

      /**
       * Process widget configuration,
       * picking options from config and from attributes.
       */
      ctrl.processConfiguration = function () {
        config = angular.copy(defaultSelectConfig);
        if ($attrs.baseConfigName) {
          var baseConfig = tlSelectConfigRegistry.getConfig($attrs.baseConfigName);
          if (baseConfig != null) {
            _.extend(config, baseConfig);
          }
        }
        if ($attrs.selectConfig) {
          var attrConfig = $scope.$eval($attrs.selectConfig);
          //console.log('config on attribute is named ' + $attrs.selectConfig, attrConfig);
          if (attrConfig) {
            $scope.attrConfig = attrConfig;
            _.extend(config, attrConfig);
          }

          // ceci est nécessaire si la config est déclarée dans le controller alors que cette partie du code est executé dans le link de la directive select.
          // le selectConfig peut donc ne pas etre encore dispo (exemple avec les fenetre $modal)
          if (!attrConfig) {
            if (unwatchSelectConfig) {
              console.error('ERROR : Config cannot be found in scope for select-config named -> ' + $attrs.selectConfig);
            } else {
              unwatchSelectConfig = $scope.$watch($attrs.selectConfig, function (newVal, oldVal) {
                if ($attrs.selectConfig && !angular.equals(newVal, oldVal) || !$scope.attrConfig) {
                  console.debug('processConfiguration again based on attibute config provided in scope', oldVal, newVal);
                  ctrl.processConfiguration();
                  // todo - surement besoin d'unwatch avant
                  if (unwatchSource) {
                    console.debug('Unwatch source');
                    unwatchSource();
                  }
                  watchSource();
                  watchSearch();
                }
              });
            }
          } else {
            // unbind le watch
            if (unwatchSelectConfig) {
              unwatchSelectConfig();
            }
          }
        }
        if ($attrs.idAttribute) {
          config.idAttribute = $attrs.idAttribute;
        }
        if ($attrs.groupBy) {
          config.groupBy = $attrs.groupBy;
        }
        if ($attrs.options) {
          config.options = $attrs.options;
          // console.log('override options with attribute options ' + $attrs.options);
        }
        if ($attrs.emptyOptionLabel) {
          config.emptyOptionLabel = $attrs.emptyOptionLabel;
        }
        if ($attrs.fixedOptionWidth) {
          config.fixedOptionWidth = $attrs.fixedOptionWidth;
        }
        if ($attrs.optionLabelAttribute) {
          config.optionLabelAttribute = $attrs.optionLabelAttribute;
        }
        if ($attrs.optionLabelFct) {
          //console.log('override options with attribute optionLabelFct ' + $attrs.optionLabelFct);
          config.optionLabelFct = $attrs.optionLabelFct;
        }
        if ($attrs.optionTemplateUrl) {
          config.optionTemplateUrl = $attrs.optionTemplateUrl;
        }
        if (config.sort && !config.sortable) {
          config.sortable = true;
        }
        if ($attrs.sortable) {
          config.sortable = $attrs.sortable;
        }
        if ($attrs.sortAttribute) {
          config.sortAttribute = $$attrs.sortAttribute;
        }

        // observe
        $attrs.$observe("disabled", function (disabled) {
          $scope.disabled = $scope.$eval(disabled) == true;
        });
        if ($attrs.optionsFilter) {
          config.optionsFilter = $scope[$attrs.optionsFilter];
        }

        // option template
        // TODO : factorisable dans templateUtils.
        if (config.optionTemplateUrl) {
          templateUtils.load(config.optionTemplateUrl).then(function (template) {
            config.optionLinkFn = $compile(template);
          });
        } else if (config.optionTemplate) {
          config.optionLinkFn = $compile(config.optionTemplate);
        } else {
          var labelOption;
          if (config.optionLabelFct) {
            // todo - ne marche pas pour le moment, erreur à la compilation
            // console.log('config.optionLabelFct', config.optionLabelFct, config);
            labelOption = '{{ ' + config.optionLabelFct + "(option)}}";
          } else {
            labelOption = '{{option.' + (config.optionLabelAttribute ? config.optionLabelAttribute : 'label') + '}}';
          }
          config.optionLinkFn = $compile('<div class="report-template-option">' + ' <span class="label">' + labelOption + '</span>' + '</div>');
        }

        // group label template
        if (config.groupLabelTemplateUrl) {
          templateUtils.load(config.groupLabelTemplateUrl).then(function (template) {
            config.groupLabelLinkFn = $compile(template);
          });
        } else if (config.groupLabelTemplate) {
          config.groupLabelLinkFn = $compile(config.groupLabelTemplate);
        }
        if (config.emptyOptionLabel && !config.emptyOption) {
          config.emptyOption = {
            $empty: true,
            label: config.emptyOptionLabel
          };
        }
        if (config.optionsFilter == null) {
          config.optionsFilter = function () {
            return true;
          };
        }
        ctrl.config = config;
      };
      var watchSearch = function watchSearch() {
        $scope.$watch("$select.state.searchTerm", $debounce(function (searchTerm, oldValue) {
          if (searchTerm === oldValue) {
            return;
          }
          refreshOptionList();
        }, 200));
      };
      var watchSource = function watchSource() {
        var sourceName = config.options;
        // console.log("watchSource config =", config);
        var unwatch = $scope.$watch(sourceName, function (sourceValue) {
          //console.log("source for options loaded : ", sourceValue);
          source = sourceValue;
          if (sourceValue !== undefined) {
            refreshOptionList();
            applyModelValue();
            console.debug('Source [' + sourceName + '] changed - sourceLoaded-> true');
            ctrl.state.sourceLoaded = true;
          }
        });
        return unwatch;
      };
      var refreshOptionList = function refreshOptionList() {
        //     console.log("source for options", source);

        var sourceValue = source;
        var emptyOption = config.emptyOption;

        // filter with given options filter
        // TODO : need to also check if the value is (was ?) selected
        sourceValue = _.filter(sourceValue, function (item) {
          return item.$forceDisplay || config.optionsFilter(item) || ctrl.state.selectedOption === item;
        });

        // Filtering source
        if (config.matcher && ctrl.state.searchTerm.length > 0) {
          sourceValue = _.filter(sourceValue, function (element) {
            return config.matcher(ctrl.state.searchTerm, element);
          });
          ctrl.setActiveOptionIdx(-1);
          $element.find(".tl-select-dropdown-options").scrollTop(0);
          emptyOption = null; // no empty option when searching ?
        }
        var groupBy = config.groupBy;
        if (groupBy) {
          var groups = [];
          var groupLabelParser = $parse(groupBy);

          // grouping options per groups
          _.each(sourceValue, function (option) {
            var optGroupByValue = groupLabelParser(option);
            var group = _.find(groups, {
              value: optGroupByValue
            });
            if (group == null) {
              group = {
                value: optGroupByValue,
                options: []
              };
              groups.push(group);
            }
            group.options.push(option);
          });

          // counting index for options inside group
          var initialIdx = 0;
          if (emptyOption != null) {
            groups.unshift({
              noGroup: true,
              options: [emptyOption]
            });
          }
          _.each(groups, function (group) {
            group.initialIdx = initialIdx;
            initialIdx += group.options.length;
          });
          ctrl.groups = groups;
        } else {
          ctrl.groups = [{
            noGroup: true,
            initialIdx: 0,
            options: sourceValue
          }];
          if (emptyOption != null) {
            ctrl.groups[0].options.unshift(emptyOption);
          }
        }

        //console.log('config.sortable', config.sortable)
        if (_.isFunction(config.sort)) {
          _.each(ctrl.groups, function (group) {
            return group.options.sort(config.sort);
          });
        } else if (config.sortable == 'true' || config.sortable === true) {
          _.each(ctrl.groups, function (group) {
            return group.options.sort(function (a, b) {
              var attrA = a[config.sortAttribute || config.optionLabelAttribute || 'label'];
              var attrB = b[config.sortAttribute || config.optionLabelAttribute || 'label'];
              return attrA < attrB ? -1 : attrA > attrB ? 1 : 0;
            });
          });
        }

        // si la source n'est pas encore chargée on ne veut laisser crtl.source à undefined
        if (ctrl.state.sourceLoaded || ctrl.groups && (ctrl.groups.length > 1 ||
        // au moins 1 option (qui peut etre celle empty)
        ctrl.groups.length > 0 && ctrl.groups[0].options.length > 0 && (ctrl.groups[0].options.length > 1 || ctrl.groups[0].options[0].$empty !== true))) {
          // to have correct indegroups[x after in-group distribution.
          ctrl.source = _.flatten(_.map(ctrl.groups, "options"));
          ctrl.state.sourceLoaded = true;
        }
        ctrl.state.loadingRenderDone = true;
      };
      ctrl.setOptionTranscludeFn = function (transcludeFn) {
        optionTranscludeFn = transcludeFn;
      };
      ctrl.getOptionTranscludeFn = function () {
        return optionTranscludeFn || config.optionLinkFn;
      };
      ctrl.setGroupLabelTranscludeFn = function (transcludeFn) {
        groupLabelTranscludeFn = transcludeFn;
      };
      ctrl.getGroupLabelTranscludeFn = function () {
        return groupLabelTranscludeFn || config.groupLabelLinkFn;
      };
      var bindEvents = function bindEvents() {
        // click on collapsed select
        $element.find(".tl-select-selection").click(function () {
          ctrl.toggleDropdown();
          $scope.$apply();
        });
        var focusOutPromise = null;
        var cancelFocusOut = function cancelFocusOut() {
          if (focusOutPromise != null) {
            $timeout.cancel(focusOutPromise);
            focusOutPromise = null;
          }
        };

        // focusin
        var selectAndDropdown = $element.add(dropdownEl);
        selectAndDropdown.bind("focusin", function (e) {
          cancelFocusOut();
          ctrl.state.focused = true;
          $scope.$apply();
        });

        // focusout
        selectAndDropdown.bind("focusout", function () {
          cancelFocusOut();
          focusOutPromise = $timeout(function () {
            $scope.$apply(function () {
              if (!ctrl.state.focused) {
                return;
              }
              if (focusIsInsideWidget()) {
                return;
              }
              ctrl.closeDropdown();
              ctrl.state.focused = false;
              focusOutPromise = null;
            });
          }, 100, false);
        });

        // Réactiver le hover si l'utilisateur bouge physiquement la souris
        dropdownEl.mousemove(function (e) {
          if (ctrl.state.ignoreHover) {
            ctrl.state.ignoreHover = false;

            // Rendre l'option survolée active immédiatement
            var optionEl = $(e.target).closest(".tl-select-dropdown-option");
            if (optionEl.length > 0) {
              var optionIdx = parseInt(optionEl.attr("option-idx"), 10);
              if (!isNaN(optionIdx) && ctrl.state.activeOptionIdx !== optionIdx) {
                $scope.$apply(function () {
                  ctrl.setActiveOptionIdx(optionIdx, false);
                });
              }
            }
          }
        });

        // keyboard events
        selectAndDropdown.keydown(function (e) {
          $scope.$apply(function () {
            // Bloquer le hover lors de la navigation au clavier
            if ([keyCodes.UP, keyCodes.DOWN, keyCodes.HOME, keyCodes.END, keyCodes.PAGE_UP, keyCodes.PAGE_DOWN].includes(e.which)) {
              ctrl.state.ignoreHover = true;
            }
            switch (e.which) {
              case keyCodes.UP:
                e.preventDefault();
                if (ctrl.isDropdownOpened()) {
                  if (ctrl.state.activeOptionIdx > 0) {
                    var idx = ctrl.state.activeOptionIdx - 1;
                    ctrl.setSelectedOptionIdx(idx, true, true);
                    ctrl.setActiveOptionIdx(idx, true);
                    ctrl.scrollToActiveOption();
                  }
                } else {
                  ctrl.openDropdown();
                }
                break;
              case keyCodes.DOWN:
                {
                  e.preventDefault();
                  if (ctrl.isDropdownOpened()) {
                    if (ctrl.state.activeOptionIdx < ctrl.source.length - 1) {
                      var _idx = ctrl.state.activeOptionIdx + 1;
                      ctrl.setSelectedOptionIdx(_idx, true, true);
                      ctrl.setActiveOptionIdx(_idx, true);
                      ctrl.scrollToActiveOption();
                    }
                  } else {
                    ctrl.openDropdown();
                  }
                  break;
                }
              case keyCodes.ESCAPE:
                e.preventDefault();
                ctrl.closeDropdown();
                break;
              case keyCodes.ENTER:
                e.preventDefault();
                if (ctrl.isDropdownOpened()) {
                  if (ctrl.state.activeOptionIdx > -1) {
                    ctrl.setSelectedOptionIdx(ctrl.state.activeOptionIdx, true);
                  } else {
                    ctrl.closeDropdown();
                  }
                } else {
                  ctrl.toggleDropdown();
                }
                break;
              case keyCodes.HOME:
              case keyCodes.PAGE_UP:
                e.preventDefault();
                ctrl.setActiveOptionIdx(0, true);
                ctrl.scrollToActiveOption();
                break;
              case keyCodes.END:
              case keyCodes.PAGE_DOWN:
                e.preventDefault();
                ctrl.setActiveOptionIdx(ctrl.source.length - 1, true);
                ctrl.scrollToActiveOption();
                break;
            }
          });
        });
      };
      ctrl.scrollToActiveOption = function () {
        if (!ctrl.state.opened) {
          return;
        }

        // TODO : when grouped by and scrolling to first option of a group, scroll up to the group label instead

        var container = dropdownEl.find(".tl-select-dropdown-options"),
          option = container.find(".tl-select-dropdown-option[option-idx=" + ctrl.state.activeOptionIdx + "]");
        if (option.length === 0) {
          return;
        }
        var currentScroll = container.scrollTop(),
          containerHeight = container.height(),
          optionPosition = option.position().top + currentScroll,
          optionHeight = option.outerHeight();
        if (optionPosition < currentScroll) {
          container.scrollTop(optionPosition);
        } else if (optionPosition + optionHeight > currentScroll + containerHeight) {
          container.scrollTop(optionPosition + optionHeight - containerHeight);
        }
      };

      /**
       * Sets the active (hovered) option index.
       *
       * @param idx The index of the option to select
       * @param [setSelected] if set to true, it will also set the option as the selected one.
       */
      ctrl.setActiveOptionIdx = function (idx, setSelected) {
        ctrl.state.activeOptionIdx = idx;
        $scope.$broadcast("tl-select:active-change", idx);
        if (setSelected && idx > -1) {
          ctrl.setSelectedOptionIdx(idx, false);
        }
      };

      /**
       * Set the selected option index.
       *
       * @param idx The index of the option to select
       * @param [apply] if set to true, will close the dropdown after selection.
       * @param keepOpen ne referme pas la liste de selection au moment de la selection
       */
      ctrl.setSelectedOptionIdx = function (idx, apply, keepOpen) {
        var selectedOption = ctrl.source[idx];
        ctrl.setSelectedOption(selectedOption, apply, keepOpen);
      };
      ctrl.setSelectedOption = function (option, apply, keepOpenOptions) {
        if (ctrl.state.selectedOption !== option) {
          option.$forceDisplay = true;
          ctrl.state.selectedOption = option;
          refreshOptionList();
        }
        if (apply) {
          if (ctrl.state.opened) {
            if (!keepOpenOptions) {
              ctrl.closeDropdown();
            }
          } else {
            syncValueToModel();
          }
        }
      };
      ctrl.setSelectedOptionById = function (optionId) {
        var apply = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        // TODO
        var idAttribute = config.idAttribute || "id";
        var selectedOption = _.find(source, function (option) {
          return objectUtils.getProperty(option, idAttribute) === optionId;
        });
        ctrl.setSelectedOption(selectedOption, apply);
      };
      ctrl.isDropdownOpened = function () {
        return ctrl.state.opened;
      };

      /**
       * Closes the select dropdown.
       * It moves the focus to the closed select if focus was inside the widget.
       */
      ctrl.closeDropdown = function () {
        if (ctrl.state.opened === false) {
          return;
        }
        if (focusIsInsideWidget()) {
          _.defer(function () {
            return $element.focus();
          });
        }
        if (ctrl.state.selectedOption !== valueAtOpening) {
          syncValueToModel(true);
        }

        // TODO : move to own method
        dropdownEl.hide().appendTo($element);
        dropdownEl.css({
          top: "",
          left: "",
          bottom: "",
          right: "",
          width: "auto"
        });
        // TODO : end

        ctrl.state.searchTerm = "";
        ctrl.state.activeOptionId = -1;
        ctrl.state.opened = false;
        ctrl.state.ignoreHover = false;
      };

      /**
       * Opens the select dropdown
       */
      ctrl.openDropdown = function () {
        if (ctrl.state.opened === true) {
          return;
        }
        valueAtOpening = ctrl.state.selectedOption;
        ctrl.state.opened = true;
        ctrl.setActiveOptionIdx(ctrl.getSelectedOptionIdx());

        // TODO : move to own method
        dropdownEl.show().appendTo(document.body);
        // la boite d'option ne dépasse pas la taille de la select. Sinon cela autorise que les options fassent des retours à la ligne.
        if (ctrl.config.fixedOptionWidth) {
          dropdownEl.outerWidth($element.outerWidth());
        }
        dropdownEl.position({
          my: "left top",
          at: "left bottom+0px",
          of: $element,
          collision: "flip",
          within: document.body
        });
        // TODO : end

        _.defer(function () {
          dropdownEl.find(".tl-select-searchbox").focus();
          ctrl.scrollToActiveOption();
        });
      };

      /**
       * Returns the index of the currently selected option
       * in the currently displayed (potentially filtered) option list
       */
      ctrl.getSelectedOptionIdx = function () {
        if (ctrl.state.selectedOption != null) {
          return _.indexOf(ctrl.source, ctrl.state.selectedOption);
        } else {
          return -1;
        }
      };

      /**
       * Toggles the dropdown
       */
      ctrl.toggleDropdown = function () {
        if (ctrl.state.opened || !ctrl.state.loadingRenderDone // pendant l'init de l'affichage on ne permet pas d'ouvrir la liste
        ) {
          ctrl.closeDropdown();
        } else {
          ctrl.openDropdown();
        }
      };
      var syncValueToModel = function syncValueToModel() {
        var emit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
        var selectedOption = ctrl.state.selectedOption;
        var modelValue;
        if (selectedOption == null || selectedOption === config.emptyOption || selectedOption.$empty) {
          modelValue = null;
        } else {
          if (config.idAttribute) {
            modelValue = objectUtils.getProperty(selectedOption, config.idAttribute);
          } else {
            modelValue = selectedOption;
          }
        }
        modelCtrl.$setViewValue(modelValue);
        modelCtrl.$commitViewValue();
        if (emit) {
          emitChangeEvent();
        }
      };

      /**
       * emit both angular and dom events to allow easy listening
       */
      var emitChangeEvent = function emitChangeEvent() {
        $scope.$emit("tl-select:change", {
          ctrl: ctrl,
          element: $element,
          value: ctrl.state.selectedOption
        });
        $element.trigger("change", {
          value: ctrl.state.selectedOption
        });
      };
      var applyModelValue = function applyModelValue() {
        var modelValue = modelCtrl.$modelValue;
        var selectedOption;
        if (modelValue == null) {
          if (config.emptyOption != null) {
            selectedOption = config.emptyOption;
          }
        } else {
          if (config.idAttribute) {
            selectedOption = _.find(source, function (option) {
              return objectUtils.getProperty(option, config.idAttribute) === modelValue;
            });
          } else {
            selectedOption = modelValue;
          }
        }
        ctrl.state.selectedOption = selectedOption;
      };
      var modelUnwatch = null;
      var wireToModel = function wireToModel() {
        if (modelUnwatch != null) {
          modelUnwatch();
        }
        modelUnwatch = $scope.$watch(function () {
          return modelCtrl.$modelValue;
        }, applyModelValue);
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/ui/selectbox/tlSelect.js
// module id = 2997
// module chunks = 13